module.exports = __webpack_public_path__ + "static/media/logo.7001faf3.png";